import React from 'react'

import { useForm } from './_load/FormLoader'
import { useSaveUser } from './_requests/saveForm'
import AccessSection from './sections/AccessSection'
import Form from '../../../packages/kiti/components/form/form/Form'
import GeneralSection from './sections/GeneralSection'
import SubmitBar from '../../../packages/kiti/components/form/SubmitBar'
import SetupSection from './sections/SetupSection'
import RedirectionSection from './sections/RedirectionSection'
import ThemeSection from './sections/ThemeSection'

const EditForm = () => {
  const form = useForm()
  const [onSubmit, { loading, error }] = useSaveUser()

  const initialForm = {
    ...form,
    validationRequired: !!form?.validationPlaceField?.id
  }

  return (
    <Form loading={loading} onSubmit={onSubmit} initialState={initialForm}>
      <GeneralSection />
      <RedirectionSection />
      <AccessSection />
      <ThemeSection />
      <SetupSection />
      <SubmitBar loading={loading} error={error} />
    </Form>
  )
}

export default EditForm
